import { Box, Typography } from '@mui/material';

export const GlobalErrorBox = ({ errors }: { errors: string[] }) => {
  if (!errors.length) return null;

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(255,76,76,.3)',
        borderLeft: '2.4px solid #ff4c4c',
        padding: '10px',
        marginBottom: '10px',
      }}
    >
      {errors.map((err, idx) => (
        <Typography key={idx} variant="body2" sx={{
          color: 'rgba(0,0,0,0.87)'
        }}>
          - {err}
        </Typography>
      ))}
    </Box>
  );
};
